<div class="chat-row" [ngClass]="{ 'chat-row--bot': author === 'bot' }">
  <!-- Main info -->
  <div class="main-info">
    <!-- Avatar icon -->
    <div class="author-avatar">
      <img
        class="author-avatar__icon"
        [src]="authorAvatar"
        (error)="onAvatarNotFound($event)"
      />
    </div>

    <!-- Message content -->
    <div
      class="message__content"
      [ngSwitch]="message.message.type"
      [ngClass]="{
        'message__content--audio': message.message.type === 'audio'
      }"
    >
      <!-- Negative mark -->
      <i
        *ngIf="
          message.scores &&
          infoMode &&
          message.author === 'client' &&
          message.scores.negative
        "
        class="material-icons negative-mark"
      >
        thumb_down
      </i>
      <!-- Text -->
      <div class="text" *ngSwitchCase="'text'">
        {{ message.message.content.text }}
      </div>
      <!-- Image -->
      <div class="image" *ngSwitchCase="'image'">
        <img src="{{ message.message.content.url }}" />
      </div>
      <!-- Video -->
      <div class="video" *ngSwitchCase="'video'">
        <video controls src="{{ message.message.content.url }}"></video>
      </div>
      <!-- Audio -->
      <div class="audio" *ngSwitchCase="'audio'">
        <audio controls src="{{ message.message.content.url }}">
          Ваш браузер не поддерживает элемент <code>audio</code>.
        </audio>
      </div>
      <!-- File -->
      <a
        target="_blank"
        [href]="message.message.content.url"
        class="file"
        *ngSwitchCase="'file'"
      >
        <i class="material-icons">save</i>
        <p>{{ message.message.content.name }}</p>
      </a>
      <!-- Default -->
      <div class="notype" *ngSwitchDefault>
        <i class="material-icons">broken_image</i>
      </div>
    </div>

    <!-- Message send time -->
    <div class="message__send-time">
      <span>{{ message.created | timeago }}</span>
    </div>
  </div>

  <!-- Additional info -->
  <div class="additional-info" [ngSwitch]="author" *ngIf="infoMode">
    <div class="additional-info--user" *ngSwitchCase="'client'">
      <ul class="user-scores" *ngIf="message.scores">
        <li class="h2b">
          <i [class]="indexColor(message.scores.happy_2_buy)"></i>
          H{{ message.scores.happy_2_buy | number: "1.0-0" }}
        </li>
        <li class="sentiment">
          <i [class]="indexColor(message.scores.sentiment)"></i>
          S{{ message.scores.sentiment | number: "1.0-0" }}
        </li>
      </ul>
    </div>
    <ng-container *ngIf="message.source">
      <div
        class="additional-info--bot"
        *ngSwitchCase="'bot'"
        [ngSwitch]="message.source.type"
      >
        <!-- Scenario -->
        <div class="scenario-step" *ngSwitchCase="'scenario'">
          <a target="_blank" [href]="scenarioUrl" class="scenario-step__link">
            {{ message.source.scenario.name }}
          </a>
          <i class="material-icons"> keyboard_arrow_right </i>
          <a target="_blank" [href]="scenarioUrl" class="scenario-step__link">
            Step {{ message.source.step.name }}
          </a>
        </div>
        <!-- Best Reply -->
        <div class="best-reply" *ngSwitchCase="'best_reply'">
          <i class="material-icons"> thumb_up </i> Best Reply
        </div>

        <!-- User Reply -->
        <div class="user-reply" *ngSwitchCase="'user'">
          <i class="material-icons"> person </i>
          {{ message.source.user.name }}
        </div>
        <!-- Intent -->
        <a
          target="_blank"
          [href]="intentUrl"
          class="intent"
          *ngSwitchCase="'intent'"
        >
          <i class="material-icons"> loyalty </i>
          {{ message.source.intent.name }}
        </a>
        <!-- System Reply -->
        <div class="system-reply" *ngSwitchCase="'system'">
          <i class="material-icons"> warning </i>
          System message
        </div>
        <a
          target="_blank"
          [href]="broadcastUrl"
          class="broadcast"
          *ngSwitchCase="'broadcast'"
        >
          <i class="material-icons"> rss_feed </i>
          {{ message.source.broadcast.name }}
        </a>
        <div class="send-status" *ngIf="sendStatus" [ngSwitch]="sendStatus">
          <i class="material-icons send" *ngSwitchCase="'send'"> check </i>
          <i class="material-icons delivered" *ngSwitchCase="'delivered'">
            done_all
          </i>
          <i class="material-icons read" *ngSwitchCase="'read'"> done_all </i>
          <i class="material-icons error" *ngSwitchCase="'error'"> info </i>
        </div>
      </div>
    </ng-container>
  </div>
</div>
